import { Box, Button, TextField } from '@mui/material'
import styled from 'styled-components'

export const PageContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 100%;
  padding: 24px 28px;
  background-color: #f5f6f8;
`

export const HeaderRow = styled(Box)`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
`

export const SaveChangesButton = styled(Button)`
  text-transform: none !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  border-radius: 8px !important;
  min-width: 150px !important;
  height: 40px !important;
  padding: 0 16px !important;
  white-space: nowrap;
`

export const PrefixInput = styled(TextField)`
  width: 180px;

  & .MuiOutlinedInput-root {
    background-color: #ffffff;
    border-radius: 6px;

    & fieldset {
      border-color: #d0d5dd;
    }

    &:hover fieldset {
      border-color: #98a2b3;
    }
  }

  & .MuiOutlinedInput-input {
    padding: 10px 12px;
    font-weight: 600;
    letter-spacing: 1px;
  }
`
